import React from 'react'
import img4 from '../../img/img4.JPG'
import '../Projects.css';


function Project3() {

    return (
        <>

            <div className='container-projects'>
                <img src={img4} />
                <div className='project-description'>
                    <h2 className='titulo-projects'>Renovation </h2>
                    The construction of the staircase for the entrance of "Café La Plaza" was carried out with the aim of improving access and the aesthetic appeal of the establishment. This project involved the creation of new stairs that not only provided safe and functional access.
                    <h1>Renovation Details:</h1>
                    <h1>Initial Evaluation and Planning:</h1><br></br>
                    Technical Inspection: A comprehensive assessment of the existing ornaments was conducted to identify wear, damage, and potential safety risks. Specifically, the railings, handrails, and decorative moldings were evaluated.<br></br><br></br>
                    Design and Planning: In collaboration with the owners, several designs were developed that combined traditional elements with modern touches. Different material and finish options were presented to ensure the satisfaction of the owners and harmony with the rest of the establishment.
                </div>
            </div>
        </>
    )



}

export default Project3